import axios, { AxiosResponse } from 'axios'
import { BASE_API_URL } from '@/configs'
import { getCookie, hasCookie } from 'cookies-next'

export const BEAPIClient = axios.create({ baseURL: BASE_API_URL, timeout: 5000 })

const getAccessToken = () => {
  if (hasCookie('accessToken')) {
    return getCookie('accessToken', {
      sameSite: process.env.NODE_ENV === 'production' ? 'none' : 'lax',
      secure: process.env.NODE_ENV === 'production',
    })
  }
  return null
}

export const AuthBEAPIClient = axios.create({
  headers: { Authorization: `Bearer ${getAccessToken()}` },
  baseURL: BASE_API_URL,
  timeout: 5000,
})

export const setAccessToken = (accessToken: unknown) => {
  AuthBEAPIClient.defaults.headers.Authorization = `Bearer ${accessToken}`
}

export const handleResponseSuccess = <T>(response: AxiosResponse<T>) => {
  return response.data
}

AuthBEAPIClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.code === 'ECONNABORTED') {
      // eslint-disable-next-line no-console
      console.error(
        'No response from API in 5 seconds',
        `Endpoint: ${error.config.url}, ${error.message}`,
      )
    }
    return Promise.reject(error)
  },
)
